export const calcMetrics = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', 'calcUse')
    : console.log('Метрика не инициализирована');
};

export const orderCall = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025ordercall')
    : console.log('Метрика не инициализирована');
};
